
























import { Component, Vue } from "vue-property-decorator";

@Component
export default class Browser extends Vue {
  content = "";
  contentMinified = "";
  isLoading = false;

  generateCode() {

    Vue.axios
      .post("https://www.ultrapixel.de/php/minify/", { url: this.content })
      .then((response) => {
       this.isLoading = false;
        if (response.data.error) {
            this.contentMinified = response.data.error;
        } else {
            this.contentMinified = response.data.response;
        }
      });
  }

  clearContent() {
    this.content = "";
    this.contentMinified = "";
  }

  copyCode() {
    navigator.clipboard.writeText(this.contentMinified);
  }
}
